import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';

import ErrorAnalysisForCharactersChartView from './ErrorAnalysisForCharactersChartView';
import ErrorAnalysisStrokeTypeInfluenceChartView from '../../common/ErrorAnalysisStrokeTypeInfluenceChartView';
import ErrorAnalysisForCharactersTableView from './ErrorAnalysisForCharactersTableView';
import ErrorAnalysisForStudentsChartView from './ErrorAnalysisForStudentsChartView';
import ErrorAnalysisForStudentsTableView from './ErrorAnalysisForStudentsTableView';
import useReportQueryParams from '../../../../hooks/use-report-query-params';
import ErrorTypeHelpInfo from '../../common/ErrorTypeHelpInfo';
import Popover from 'components/@common/Popover';
import { ModuleType, ReportDisplayBy, ReportView } from '../../../../types';

const ClassroomErrorAnalysisCards: React.FC = () => {
  const [{ viewAs, displayBy }] = useReportQueryParams();
  const { t } = useTranslation('Reports');

  const REPORT_VIEW_MAP: { [key in ReportView]?: any } = {
    [ReportView.CHART]: {
      [ReportDisplayBy.CHARACTERS]: ErrorAnalysisForCharactersChartView,
      [ReportDisplayBy.STUDENTS]: ErrorAnalysisForStudentsChartView
    },
    [ReportView.TABLE]: {
      [ReportDisplayBy.CHARACTERS]: ErrorAnalysisForCharactersTableView,
      [ReportDisplayBy.STUDENTS]: ErrorAnalysisForStudentsTableView
    }
  };

  const ErrorAnaysisComponent = REPORT_VIEW_MAP[viewAs][displayBy ?? ReportDisplayBy.STUDENTS];

  return (
    <section>
      <Popover description={<ErrorTypeHelpInfo />}>
        <Typography variant="h3">{t('Error Analysis')}</Typography>
      </Popover>
      <ErrorAnaysisComponent module={ModuleType.CAPITALS} />
      <ErrorAnaysisComponent module={ModuleType.LOWERCASE} />
      <ErrorAnaysisComponent module={ModuleType.NUMBERS} />

      {viewAs === ReportView.CHART && (
        <Grid item xs={6} lg={3}>
          <ErrorAnalysisStrokeTypeInfluenceChartView />
        </Grid>
      )}
    </section>
  );
};

export default React.memo(ClassroomErrorAnalysisCards);
